import { Box, Grid, Link, TableContainer, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { FieldTitle, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import useNotify from "../../unit/useNotify";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import CustomButtonSave from "../../unit/CustomButtonSave";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import HeaderLabelGridField from "../../unit/HeaderLabelGridField";
import PaperComponent from "../../unit/PaperComponent";
import NoResults from "../../unit/NoResults";
import formatAccountNumber from "../../unit/formatAccountNumber";
const CustomPreviewData = ({ ...props }) => {
  const dataArray = props.data;

  let prev: null = null;
  const getActualInterestAmountPaid = (item: any, prev: any) => {
    let dActualAmountPaid = parseFloat(item.dActualAmountPaid);
    let interestAmount_total = 0;
    let latefee_total = 0;
    if (prev && prev.dInterestPastDueSum) {
      interestAmount_total =
        parseFloat(item.interestAmount) + parseFloat(prev.dInterestPastDueSum);
    } else {
      interestAmount_total = parseFloat(item.interestAmount);
    }
    if (prev && prev.dLateFeePastDueSum) {
      latefee_total =
        parseFloat(item.dLateFees) + parseFloat(prev.dLateFeePastDueSum);
    } else {
      latefee_total = parseFloat(item.dLateFees);
    }
    if (interestAmount_total > 0) {
      if (dActualAmountPaid >= interestAmount_total) {
        return dActualAmountPaid > 0
          ? formatCurrency(interestAmount_total)
          : "";
      } else {
        return dActualAmountPaid > 0 ? formatCurrency(dActualAmountPaid) : "";
      }
    } else {
      return dActualAmountPaid > 0 ? formatCurrency(dActualAmountPaid) : "";
    }
  };

  let show_invoice_edit = false;
  let latefeeSum = 0;
  let eq_cal = 0;

  return (
    <TableContainer
      component={CustomPaper}
      sx={{
        mt: 2,
        width: `calc(100%)`,
        height: `280px`,
        overflow: "auto",
      }}
    >
      <CustomTable
        stickyHeader
        sx={{
          "& .MuiTableRow-head": {
            border: "1px solid #d5d5d5",
            backgroundColor: "#edf4fb",
            height: "50px",
            maxHeight: "50px",
            color: "red",
          },

          "& .MuiTableCell-head": {
            backgroundColor: "#edf4fb",
            height: "50px",
            maxHeight: "50px",
          },
        }}
      >
        <TableHead>
          <TableRow>
            {/* <TableCell>Payment Number</TableCell> */}
            <TableCell>Payment Due Date</TableCell>
            <TableCell align="right">Expected Payment Amount</TableCell>
            {/* <TableCell>Invoice Amount</TableCell>
          <TableCell>Actual Payment Date</TableCell>
          <TableCell>Actual Payment Amount</TableCell> */}
            {/* 
             <TableCell>Interest Paid</TableCell>
          <TableCell>Principal Paid</TableCell>
          <TableCell>Cumulative Principal Balance</TableCell>
          <TableCell>Remaining Principal Balance</TableCell> */}
            {/* <TableCell>Days Past Due</TableCell>
          <TableCell>Amount Past Due</TableCell>
          <TableCell>Late Fees</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {dataArray == undefined ||
          dataArray.length == 0 ||
          dataArray == null ? (
            <TableRow>
              <TableCell colSpan={13} className="no-results">
                <NoResults />
              </TableCell>
            </TableRow>
          ) : (
            <>
              {dataArray.map((item: any, index: any) => {
                if (item.dActualAmountPaid > 0 && item.principalReduction > 0) {
                  eq_cal += item.principalReduction;
                }
                if (index > 0) {
                  prev = dataArray[index - 1];
                }
                if (item.sStatus != "pending") {
                  // continue;
                  return null;
                }

                return (
                  <TableRow key={index}>
                    {/* <TableCell>{index + 1}</TableCell> */}
                    <TableCell>{formatDate(item.dPaymentDate)}</TableCell>
                    <TableCell align="right" className="amountText">
                      {formatCurrency(item.paymentAmount)}
                    </TableCell>
                    {/* <TableCell>
                    {item.dPaymentDate < new Date()
                      ? formatCurrency(item.dOriginalInvoiceAmount)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dLastActualPaidDate != "" &&
                    item.dLastActualPaidDate != "0000-00-00 00:00:00"
                      ? formatDate(item.dLastActualPaidDate)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0
                      ? formatCurrency(item.dActualAmountPaid)
                      : ""}
                  </TableCell> */}
                    {/* 
                    <TableCell>
                    {getActualInterestAmountPaid(item, prev)}
                  </TableCell>
                    <TableCell>
                    {getActualInterestAmountPaid(item, prev)}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 && item.principalReduction > 0
                      ? formatCurrency(item.principalReduction)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 ||
                    item.sStatus == "expired" ||
                    item.sStatus == "failed"
                      ? formatCurrency(eq_cal)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {item.dActualAmountPaid > 0 && item.dActualLoanBalance > 0
                      ? formatCurrency(item.dActualLoanBalance)
                      : ""}
                  </TableCell> */}
                    {/* <TableCell>{item.iDaysPastDue}</TableCell>
                  <TableCell>{formatCurrency(item.dAmountPastDue)}</TableCell>
                  <TableCell>{formatCurrency(item.dLateFees)}</TableCell> */}
                  </TableRow>
                );
              })}
            </>
          )}
        </TableBody>
      </CustomTable>
    </TableContainer>
  );
};
export default function CustomLoanSkipDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const lastDate = record?.lastDate;
  const [previewData, setPreviewData] = React.useState<any[]>([]);
  const [revisedData, setRevisedData] = React.useState<any[]>([]);
  const accruedInterestAmount = record?.accruedInterestAmount;
  const oldAmount = record?.unpaid_principal?.toString();
  const [balance, setBalance] = React.useState(oldAmount);
  const nextPaymentAmount = record?.loan?.nextPaymentAmount;
  const currentPaymentDate = record?.curPV?.dPaymentDate;

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const newPaymentDate = dayjs
    .tz(record?.nextPV?.dPaymentDate, "America/New_York")
    .format("YYYY-MM-DD");
  // console.log("====>", newPaymentDate);
  const showSkipExtend = record?.showSkipExtend ? true : false;
  const [open, setOpen] = React.useState(false);
  const newMaturityDateDefault = dayjs
    .tz(record?.loan?.maturityDate, "America/New_York")
    .format("YYYY-MM-DD");
  const [maturityDate, setMaturityDate] = React.useState(
    newMaturityDateDefault
  );
  let curPaymentFrequency = record?.loan?.paymentFrequency;
  let newDefaultMaturityDate = newMaturityDateDefault;
  //根据curpaymentFrequency 设置新的默认的maturityDate， 添加一个周期
  if (
    curPaymentFrequency == "Monthly" ||
    curPaymentFrequency == "Single Repayment"
  ) {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(1, "month")
      .format("YYYY-MM-DD");
  } else if (curPaymentFrequency == "Bi-Weekly") {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(2, "week")
      .format("YYYY-MM-DD");
  } else if (curPaymentFrequency == "Weekly") {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(1, "week")
      .format("YYYY-MM-DD");
  } else if (curPaymentFrequency == "Semimonthly") {
    newDefaultMaturityDate = dayjs(newDefaultMaturityDate)
      .add(15, "day")
      .format("YYYY-MM-DD");
  }

  const [newMaturityDate, setNewMaturityDate] = React.useState(
    newDefaultMaturityDate
  );
  const [paymentCount, setPaymentCount] = React.useState(0);
  const [isSubmit, setIsSubmit] = React.useState(true);
  const [submitFormData, setSubmitFormData] = React.useState({
    add_accumulated_interest_to_balance: false,
    amount: oldAmount.toString(),
    oldAmount: record?.unpaid_principal,
    interest_rate: record?.loan?.interestRate,
    noteDate: dayjs(new Date(newPaymentDate)).format("YYYY-MM-DD"),
    firstPaymentDate: dayjs(new Date(newPaymentDate)).format("YYYY-MM-DD"),
    maturityDate: "",
    paymentFrequency: record?.loan?.paymentFrequency,
    recalculate_schedule_given_payment_amount: false,
    fixed_payment_amount: nextPaymentAmount,
    payment_number: record?.loan?.remainingPayments,
    payment_terms: record?.loan?.remainingPayments,
    iPaymentRoundUp: record?.loan?.paymentRoundUp,
    reason: "",
    notes: "",
    late_fee: "",
    grace_period: "",
    paymentMethod: "",
    paymentMonth: "",
  });
  const [submitTitle, setSubmitTitle] = React.useState("Confirm");
  const [previewTitle, setPreviewTitle] = React.useState("Preview");
  const refresh = useRefresh();
  const handleClickOpen = () => {
    //when  getMaturityDate(); is called, it will set the submitFormData.maturityDate and submitFormData.payment_terms, after open the dialog
    getMaturityDate();
    setOpen(true);
    if (props?.cb) {
      props?.cb();
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSubmitTitle("Confirm");
    setPreviewTitle("Preview");
    setPreviewData([]);
    setRevisedData([]);
    // refresh();
  };
  const handleRefreshFun = () => {
    refresh();
  };

  const calMatDate = async () => {
    let checkCalFun = true;

    //first payment date > today and first payment date > note date
    if (dayjs(formSubData.first_payment_date).isBefore(dayjs(), "day")) {
      errorNotify("First Payment Date must be greater than today");
      checkCalFun = false;
    }
    if (
      dayjs(formSubData.first_payment_date).isBefore(
        dayjs(formSubData.note_date),
        "day"
      )
    ) {
      errorNotify("First Payment Date must be greater than Note Date");
      checkCalFun = false;
    }
    const formJson = {
      amouant: formSubData.amount,
      note_date: formSubData.note_date,
      iterm: formSubData.payment_number,
      payment_frequency: formSubData.payment_frequency,
      rate: formSubData.rate,
      first_payment_date: formSubData.first_payment_date,
    };

    // console.log("calMatDate formJson===>", formJson);
    // console.log("calMatDate checkCal===>", checkCal);

    if (checkCalFun == false) {
      return false;
    } else {
      const reqUrl = `calculate/getmaturitydate`;
      const response = await sendRequest(reqUrl, {
        id: appId,
        data: formJson,
      });
      if (response && response.status == "200") {
        // successNotify(
        //   "Maturity date calculated successfully " + response.data.maturity_date
        // );
        setMaturityDate(
          dayjs(response.data.maturity_date).format("YYYY-MM-DD")
        );
        setPaymentCount(response.data.payment_count);
      } else {
        errorNotify("Error in calculating maturity date");
      }
    }
  };

  const handleSubmitModify = async () => {
    const formJson = {
      userset: "yes",
      skipexpired: "",
      type: "skipPayment",
      applicationId: appId,
      // note_date: submitFormData.noteDate,
      note_date: dayjs().tz("America/New_York").format("YYYY-MM-DD"),
      first_payment_date: submitFormData.firstPaymentDate,
      org_payment_date: currentPaymentDate,
      org_maturity_date: maturityDate,
      payment_frequency: submitFormData.paymentFrequency,
      rate: submitFormData.interest_rate,
      amount: submitFormData.amount,
      oldamount: submitFormData.oldAmount,
      reason: submitFormData.reason,
      notes: submitFormData.notes,
      late_fee: submitFormData.late_fee,
      grace_period: submitFormData.grace_period,
      payment_number: submitFormData.payment_number,
      payment_terms: submitFormData.payment_terms,
      maturity_date: submitFormData.maturityDate,
      iPaymentRoundUp: submitFormData.iPaymentRoundUp,
      fixed_payment_amount: submitFormData.fixed_payment_amount,
      paymentMethod: submitFormData.paymentMethod,
      paymentMonth: submitFormData.paymentMonth,
      //"origination_fee_type":$('#createPaymentScheduleModal').find('#origination_fee_type').val()
    };
    setSubmitTitle("loading");
    const reqUrl = `create/payment/schedule`;
    const responseBack = await sendRequest(reqUrl, {
      id: appId,
      data: formJson,
    });
    if (responseBack && responseBack.code == "200") {
      let previewData = responseBack.data;
      setPreviewData([]);
      setRevisedData([]);
      successNotify("Data saved successfully");
      handleRefreshFun();
      handleClose();
    } else {
      errorNotify(responseBack?.message || "Data not saved!");
    }

    setIsSubmit(false);
    setPreviewData([]);
    setRevisedData([]);
    setSubmitTitle("Confirm");
  };

  const getMaturityDate = async () => {
    console.log("getMaturityDate submitFormData===>", submitFormData);

    const formJson = {
      userset: "yes",
      applicationId: appId,
      payment_frequency: submitFormData.paymentFrequency,
      amount: Number(submitFormData.amount),
      iterm: Number(record?.terms),
      rate: submitFormData.interest_rate,
      first_payment_date: submitFormData.firstPaymentDate,
      // note_date: submitFormData.noteDate,
      note_date: dayjs().tz("America/New_York").format("YYYY-MM-DD"),
      payment_number: Number(submitFormData.payment_number),
      payment_terms: Number(submitFormData.payment_terms),
      maturity_date: "",
      fixed_payment_amount: submitFormData.fixed_payment_amount,
      paymentMethold: "",
      paymentMonth: "",
    };

    console.log("getMaturityDate formJson===>", formJson);

    if (
      formJson.amount == null ||
      formJson.amount == 0 ||
      // formJson.rate == "" ||
      formJson.rate == null ||
      formJson.payment_number == null ||
      formJson.payment_number == 0 ||
      formJson.payment_frequency == "" ||
      formJson.payment_frequency == null ||
      formJson.first_payment_date == "" ||
      formJson.first_payment_date == null ||
      formJson.note_date == "" ||
      formJson.note_date == null
    ) {
      errorNotify("Please fill in all the required fields");
      return false;
    }

    const reqUrl = `calculate/getmaturitydate`;
    const response = await sendRequest(reqUrl, {
      id: appId,
      data: formJson,
    });
    if (response && response.status == "200") {
      setSubmitFormData({
        ...submitFormData,
        maturityDate: response.data.maturity_date,
        payment_terms: response.data.terms,
      });
      setIsSubmit(true);
    } else {
      errorNotify("Error in calculating maturity date");
    }
  };

  const RevisedTable = ({ ...props }) => {
    const revisedData = props.revisedData;
    const curPV = props?.curPV;
    // console.log("revisedData in RevisedTable===>", revisedData);
    // console.log("curPV in RevisedTable===>", curPV);
    return (
      <>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Remaining Principal:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {formatCurrency(record?.unpaid_principal)}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Remaining Principal:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {formatCurrency(revisedData.amount)}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Interest Rate:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.interestRate}%
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Interest Rate:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData?.rate}%
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Payment Frequency:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {record?.loan?.paymentFrequency}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Payment Frequency:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData?.paymentfrequency}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Maturity Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {maturityDate ? formatDate(maturityDate) : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Maturity Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.maturitydate
              ? formatDate(revisedData.maturitydate)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Next Payment Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {currentPaymentDate ? formatDate(currentPaymentDate) : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Next Payment Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.nextpaymentdate
              ? formatDate(revisedData.nextpaymentdate)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Next Payment Due:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {nextPaymentAmount ? formatCurrency(nextPaymentAmount) : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Next Payment Due:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.nextpaymentamount
              ? formatCurrency(revisedData.nextpaymentamount)
              : ""}
          </Grid>
        </Grid>
        <Grid container sx={{ mb: 0, mt: 2 }}>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Current Term Starting Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {curPV?.dModifyNoteDate &&
            curPV?.dModifyNoteDate != "0000-00-00" &&
            curPV?.dModifyNoteDate != "0000-00-00 00:00:00"
              ? `${formatDate(curPV?.dModifyNoteDate)}`
              : curPV?.dNoteDate &&
                curPV?.dNoteDate != "0000-00-00 00:00:00" &&
                curPV?.dNoteDate != "0000-00-00"
              ? `${formatDate(curPV?.dNoteDate)}`
              : ""}
          </Grid>
          <Grid item xs={3}>
            <HeaderLabelTitle title="Revised Term Starting Date:" suffix="" />
          </Grid>
          <Grid item xs={3}>
            {revisedData.startdate ? formatDate(revisedData.startdate) : ""}
          </Grid>
        </Grid>
      </>
    );
  };
  if (showSkipExtend == false) {
    return (
      <Link
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
          color: "grey",
        }}
      >
        Skip Upcoming Payment
      </Link>
    );
  }
  return (
    <React.Fragment>
      {/* <Button
          label="Skip Next Payment"
          variant="text"
          size="medium"
          // color="error"
          sx={{
            marginLeft: "10px",
            "&:hover": {
              background: "none",
            },
          }}
          disabled={!showSkipExtend}
          onClick={handleClickOpen}
        /> */}
      <Link
        id="link-loan-skip-next-payment"
        sx={{
          marginLeft: "10px",
          "&": { textDecoration: "none" },
          "&:hover": {
            background: "none",
          },
        }}
        onClick={handleClickOpen}
      >
        Skip Upcoming Payment
      </Link>
      <Dialog
        id="dialog-loan-skip-next-payment"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            // console.log("submitFormData===============>", submitFormData);
            // return false;
            const formJson = {
              userset: "yes",
              skipexpired: "",
              type: "skipPayment",
              applicationId: appId,
              // note_date: submitFormData.noteDate,
              // today
              note_date: dayjs().tz("America/New_York").format("YYYY-MM-DD"),
              org_payment_date: currentPaymentDate,
              org_maturity_date: maturityDate,
              first_payment_date: submitFormData.firstPaymentDate,
              payment_frequency: submitFormData.paymentFrequency,
              rate: submitFormData.interest_rate,
              amount: submitFormData.amount,
              oldamount: submitFormData.oldAmount,
              reason: submitFormData.reason,
              notes: submitFormData.notes,
              late_fee: submitFormData.late_fee,
              grace_period: submitFormData.grace_period,
              payment_number: submitFormData.payment_number,
              payment_terms: submitFormData.payment_terms,
              maturity_date: submitFormData.maturityDate,
              iPaymentRoundUp: submitFormData.iPaymentRoundUp,
              fixed_payment_amount: submitFormData.fixed_payment_amount,
              paymentMethod: submitFormData.paymentMethod,
              paymentMonth: submitFormData.paymentMonth,
              //"origination_fee_type":$('#createPaymentScheduleModal').find('#origination_fee_type').val()
            };
            setPreviewTitle("loading");
            const reqUrl = `create/payment/schedule/preview`;
            const responseBack = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });
            // console.log("responseBack data ====>", responseBack.data);
            if (responseBack && responseBack.code == "200") {
              let previewData = responseBack.data;
              let revisedData = responseBack?.revisedData;
              setRevisedData(revisedData);
              let previewDataArray = [];
              for (let key in previewData) {
                previewDataArray.push(previewData[key]);
              }
              setPreviewData(previewDataArray);
              successNotify("Data saved successfully");
              // handleClose();
            } else {
              errorNotify(responseBack?.message || "Data not saved!");
            }
            setPreviewTitle("Confirm");
          },
        }}
      >
        <DialogTitle
          sx={{
            borderBottom: "1px solid #e5e5e5",
            mb: 1,
          }}
        >
          <CustomDialogTitle
            title={`${record?.loan?.loanStatus} Loan`}
            subTitle="Skip Upcoming Payment"
          />
        </DialogTitle>
        <DialogContent>
          <Box>
            <DialogContentText>
              This function lets borrower skip the upcoming payment by shifting
              future payment schedule forward by one payment cycle. Interest
              will continue to accrue during the skipped period, resulting in an
              increase to the last scheduled payment amount. Available only for
              loans that are current and before the end of Payment Grace Period.
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{ my: 2, color: "red" }}
              >
                Resetting payment schedule of any kind is limited to only once
                per day. This change is irreversible. Please check all the
                inputs and carefully preview the results before clicking
                “Confirm” to commit the changes.
              </Typography>
              {!previewData.length && (
                <Grid container>
                  <Grid item xs={3}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="Payment ID"
                      value={record?.curPV?.iId}
                      className="numericText"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="Amount Scheduled"
                      value={
                        nextPaymentAmount
                          ? formatCurrency(nextPaymentAmount)
                          : ""
                      }
                      className="amountText"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="Current Scheduled Date"
                      value={
                        currentPaymentDate ? formatDate(currentPaymentDate) : ""
                      }
                      className="numericText"
                    />
                  </Grid>
                  <Grid item xs={3}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="New Payment Date"
                      value={newPaymentDate ? formatDate(newPaymentDate) : ""}
                      className="dateText"
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ mt: 1 }}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="Current Remaining Payments"
                      value={record?.loan?.remainingPayments}
                      className="numericText"
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ mt: 1 }}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="New Remaining Payments"
                      value={record?.loan?.remainingPayments}
                      className="numericText"
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ mt: 1 }}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="Current Maturity Date"
                      value={maturityDate ? formatDate(maturityDate) : ""}
                      className="numericText"
                    />
                  </Grid>
                  <Grid item xs={3} sx={{ mt: 1 }}>
                    <HeaderLabelGridField
                      dxs={12}
                      tdxs={12}
                      title="New Maturity Date"
                      value={newMaturityDate ? formatDate(newMaturityDate) : ""}
                      className="dateText"
                    />
                  </Grid>
                </Grid>
              )}
            </DialogContentText>
            {previewData.length ? (
              <>
                <RevisedTable revisedData={revisedData} curPV={record?.curPV} />
                <CustomPreviewData data={previewData} />
              </>
            ) : (
              <Grid container sx={{ mb: 0, pb: 2 }}>
                <Grid sx={{ mb: 0, mt: 2 }} container>
                  <HeaderLabelTitle
                    title="Add Note (Max 150 Characters)"
                    suffix=""
                  />
                </Grid>
                <Grid sx={{ mb: 0 }} container>
                  <TextField
                    id="notes"
                    name="notes"
                    value={submitFormData.notes}
                    onChange={(e) => {
                      setSubmitFormData({
                        ...submitFormData,
                        notes: e.target.value,
                      });
                    }}
                    onKeyDown={(event) => {
                      event.stopPropagation();
                    }}
                    placeholder="Notes"
                    multiline={true}
                    minRows={2}
                    fullWidth
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          {isSubmit && !previewData.length && (
            <CustomButtonSubmit
              label={previewTitle}
              disabled={previewTitle == "loading" ? true : false}
            />
          )}
          {previewData.length > 0 && (
            <CustomButtonSave
              color="primary"
              onClick={handleSubmitModify}
              label={submitTitle}
              variant="contained"
              disabled={submitTitle == "loading" ? true : false}
            />
          )}
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
